<template>
  <div class="flex flex-col mx-auto pt-12 w-100 container max-w-3xl">
    <h1 class="text-4xl text-gray-900 tracking-tight">
      Welcome to the Campflare Platform
    </h1>
    <div class="text-xl text-gray-600 mt-2">
      Thank you for using the Campflare API.
    </div>
    <h2 class="mt-12 text-gray-900 text-2xl tracking-tight">Getting Started</h2>
    <div class="flex space-x-12 mt-4">
      <a
        href="https://docs-v2.campflare.com/"
        target="_blank"
        class="flex-1 h-40 rounded relative cursor-pointer hover:-translate-y-[2px] transition"
        style="background: linear-gradient(to right, #8fa881, #c7bca6)"
      >
        <div class="absolute bottom-4 left-4">
          <div class="text-white font-bold">Start Fetching Data</div>
          <div class="text-white opacity-90">
            Insert data into your application
          </div>
        </div>
      </a>
      <a
        href="/platform/account"
        class="flex-1 h-40 rounded relative cursor-pointer hover:-translate-y-[2px] transition"
        style="background: linear-gradient(to right, #7a9a6a, #4a5c3f)"
      >
        <div class="absolute bottom-4 left-4">
          <div class="text-white font-bold">Manange your Account</div>
          <div class="text-white opacity-90">Set your webhooks and keys</div>
        </div>
      </a>
    </div>

    <h2 class="mt-12 text-gray-900 text-2xl tracking-tight">
      A message from us
    </h2>
    <div class="text-xl text-gray-600 mt-2">
      The primary goal of this API is to increase the accessibility of our
      public lands — use it do to so. Please, reach out
      <a
        href="mailto:support@campflare.com"
        target="_blank"
        class="text-primary hover:opacity-50"
        >to us</a
      >
      if you want help integrating the Campflare API into your product. We are
      always happy to assist.
    </div>
  </div>
</template>
